import React, { Component } from "react";
import SingleMap from "../../components/MapComp/SingleMap";
// import SignupPopup from "../../components/PopupComp/SignupPopup";
import "./style.scss";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: {
        id: "contact",
        address: "Søndergade 8, 2. th <br/> DK-8000 Aarhus C",
        location: {
          lat: "56.1552809",
          lng: "10.207286"
        }
      }
    };
  }
  render() {
    console.log(this.props);
    return (
      <div id="contact_page">
        {/* <SignupPopup /> */}
        <div className="row1">
          <div className="address">
            <h2>Contact us</h2>

            <div className="form-group">
              <i className="fa fa-map-marker" />
              <span>
                Søndergade 8, 2. th <br />
                DK-8000 Aarhus C
              </span>
            </div>

            <div className="form-group">
              <i className="fa fa-volume-control-phone" />
              <a href="tel:+4571993316">+45 7199 3316</a>
            </div>

            <div className="form-group">
              <i className="fa fa-comments" />
              <a href="mailto:info@heydesk.com" subject="Heydesk | Contact us">
                info@heydesk.com
              </a>
            </div>

            <div className="form-group">
              <i className="fa fa-info" />
              <a href="/terms">Terms, Conditions &amp; Privacy policy</a>
            </div>
          </div>

          <div className="contact_map">
            <SingleMap listing={this.state.location} priceCalculation="unset" />
          </div>
        </div>
      </div>
    );
  }
}
